import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/MDRT.App.UI/apps/mdrt-org/src/app/global-error.tsx");
